var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  style: {
    transform: "scale(1.25)"
  },
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M14.55 5.754a3.2 3.2 0 0 1 .9 0c.499.07.985.302 2.256.937l3.806 1.904c1.447.723 2.478 1.24 3.193 1.696.729.465.97.773 1.046 1.008.123.381.112.794-.032 1.168-.09.23-.346.525-1.1.95-.739.417-1.796.876-3.281 1.52l-3.933 1.704c-1.135.491-1.568.671-2.007.725a3.3 3.3 0 0 1-.796 0c-.44-.054-.872-.234-2.007-.725l-3.933-1.704c-1.484-.644-2.542-1.103-3.281-1.52-.754-.425-1.01-.72-1.1-.95a1.75 1.75 0 0 1-.032-1.168c.076-.235.317-.543 1.046-1.008.715-.456 1.746-.973 3.193-1.696l3.806-1.905c1.27-.635 1.757-.867 2.256-.937Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.015 13.866c.409.18.904.364 1.492.57-.004.399-.007.848-.007 1.364v3.42c0 1.053.015 1.283.196 1.714a5 5 0 0 0 .459.717c.22.24.337.33.414.382.096.064.198.114.502.254 1.321.608 3.293 1.213 5.929 1.213 1.114 0 2.114-.07 3-.18v1.511c-.9.104-1.899.169-3 .169-2.693 0-4.782-.58-6.267-1.22l-.289-.13c-.567-.26-.85-.391-1.396-.988-.19-.208-.514-.701-.676-1.02l-.058-.125C6 20.772 6 20.254 6 19.22V15.8c0-.743.001-1.38.015-1.934"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "m15.75 11.5 7.5 3V20"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M21.434 20.81c.748-1.496 2.884-1.496 3.632 0 .676 1.351-.306 2.94-1.816 2.94s-2.492-1.589-1.816-2.94Z"
})));
export default SvgLearn;